import { Controller } from '@hotwired/stimulus';
import { Collapse } from 'bootstrap';

// Connects to data-controller="profile-menu"
export default class extends Controller {
  static targets = ['collapse'];

  closeOnClickOutside(event) {
    if (this.element.contains(event.target)) return;

    this.close();
  }

  close() {
    if (!this.hasCollapseTarget) return;

    const bsCollapse = Collapse.getInstance(this.collapseTarget);
    if (bsCollapse) bsCollapse.hide();
  }
}
